export class GCPortalkarteBaseClass {

    protected jquery: any;
    protected ol: any;
    protected proj4: any;

    /**
     *
     */
    public constructor() {
        this.jquery = window['jQuery'] || null;
        this.ol = window['ol'] || null;
        this.proj4 = window['proj4'] || null;
    }

    /**
     *
     * @param {string} projectionName
     */
    public registerProjection(projectionName:string)
    {
        if (this.proj4 && this.ol) {
            this.proj4.defs("EPSG:31466", "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs");
            this.proj4.defs("EPSG:31467", "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs");
            this.proj4.defs("EPSG:31468", "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs");
            this.proj4.defs("EPSG:31469", "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs");
            this.proj4.defs("EPSG:25832", "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
            this.proj4.defs("EPSG:25833", "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
            this.proj4.defs("EPSG:32632", "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs"); // WGS 84 / UTM zone 32N
            this.proj4.defs("EPSG:32633", "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs +type=crs");// WGS 84 / UTM zone 33N

            this.ol.proj.proj4.register(this.proj4);
        }
        return this;
    }

    public getOL()
    {
        return this.ol;
    }

    public getJQuery()
    {
        return this.jquery;
    }

    public getProj4()
    {
        return this.proj4;
    }
}